import { createSelector } from 'reselect';
import { getPlatformEnvironment } from '../../../app/reducers/configuration';
import {
    getEnvironmentDigitalKeyApplicationIdHandler,
    getEnvironmentExpediaApplicationIdHandler,
    getEnvironmentFlexkeepingApplicationIdHandler,
} from './handlers';

export const getExpediaApplicationId = createSelector(
    getPlatformEnvironment,
    getEnvironmentExpediaApplicationIdHandler
);

export const getFlexkeepingApplicationId = createSelector(
    getPlatformEnvironment,
    getEnvironmentFlexkeepingApplicationIdHandler
);

export const getDigitalKeyApplicationId = createSelector(
    getPlatformEnvironment,
    getEnvironmentDigitalKeyApplicationIdHandler
);
